import { useState, useEffect } from "react";
import {
  PaymentRequestButtonElement, useStripe,
} from "@stripe/react-stripe-js";

import { MODAL_MESSAGES } from "../../components/common/helpers";
import { addInvestment, sendEmailApproval } from '../../actions/investments';

import { useDispatch } from 'react-redux';

const ApplePayButton = ({
  newInvestment, user,
  setModalContent, setShowModal, setLoading
}) => {
  const dispatch = useDispatch();
  const stripe = useStripe();
  const [paymentRequest, setPaymentRequest] = useState(null);

  useEffect(() => {
    if (stripe && newInvestment.monto > 5) {
      const pr = stripe.paymentRequest({
        country: "MX",
        currency: "mxn",
        total: {
          label: "Inversión",
          amount: Math.floor(newInvestment.monto * 100)
        },
        requestPayerName: true,
        requestPayerEmail: true,
      });

      pr.canMakePayment().then(result => {
        if (result && result.applePay) {
          setPaymentRequest(pr);
        }
      });
    }
  }, [stripe, newInvestment]);

  useEffect(() => {
    if (paymentRequest) {
      paymentRequest.on("paymentmethod", async (ev) => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/payments/create-payment-intent`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            amount: Math.floor(newInvestment.monto * 100), // Monto en centavos
          }),
        });
        setLoading(true);
        const { clientSecret } = await res.json();

        const { error: confirmError, paymentIntent } = await stripe.confirmCardPayment(
          clientSecret,
          {
            payment_method: ev.paymentMethod.id,
          },
          { handleActions: false }
        );

        if (confirmError) {
          console.error("Error confirming payment:", confirmError);
          ev.complete("fail");
          setLoading(false);
          const result = MODAL_MESSAGES.ERROR_INVERSION;
          setModalContent(result);
          setShowModal(true);
        } else {
          const info = {
            monto: Math.floor(paymentIntent.amount / 100),
            recibo: [ev.paymentMethod.id],
            metodo: 'applePay',
            status: 1,
            tipo: "Servicio",
            servicio: newInvestment?.servicio
          };
          console.log('Pago exitoso:', info);
          const emailData = {
            subject: 'aprobacion',
            email: user.email,
            nombre: user.name,
            servicio: true
          };
          await dispatch(addInvestment(info, user._id, user.datos_empresas[0]._id));
          await sendEmailApproval(emailData);
          const result = MODAL_MESSAGES.SUCCESS_INVERSION;
          setModalContent(result);
          ev.complete("success");
          setLoading(false);
          setShowModal(true);
        }
      });
    }
  }, [paymentRequest, stripe]);

  if (!paymentRequest) return null;

  return (
    <div>
      <PaymentRequestButtonElement options={{ paymentRequest }} />
    </div>
  );
}

export default ApplePayButton;
